// extracted by mini-css-extract-plugin
export default {"header":"header_header__7gaZV","panel":"header_panel__BFQOi","menu":"header_menu__Jr0x5","visible":"header_visible__f6zsv","bg":"header_bg__cQQ-D"};